import { ApiProperty } from "@nestjs/swagger";
import { BomDto } from "./bom-dto";

export class StyleBomDto {

    @ApiProperty()
    styleId?: number

    @ApiProperty()
    style?: string

    @ApiProperty()
    styleName?: string

    @ApiProperty()
    season?: string

    @ApiProperty()
    year?: string

    @ApiProperty()
    msc?: string

    @ApiProperty()
    kimbleSize?: string

    @ApiProperty()
    styleType?:string

    @ApiProperty()
    isFleece?:string

    constructor(
        styleId?: number,
        style?: string,
        styleName?: string,
        season?: string,
        year?: string,
        msc?: string,
        styleType?:string,
        isFleece?:string

    ) {
        this.styleId = styleId
        this.style = style
        this.styleName = styleName
        this.season = season
        this.year = year
        this.msc = msc
        this.isFleece = isFleece
        this.styleType = styleType
    }
}